import axios from "http/customAxios";
import { IPropertyChainData } from "../../components/chain-data-provider";
import { IHttpClient } from "../../lib/http";
import { regenPropertyCache } from "../common/api";
import { MIDDLEWARE_URL } from "../witadmin/request";

export async function updatePropertyDefaultBrand(
  cacheClient: IHttpClient,
  propertyTicker: string,
  defaultBrand: string | null
) {
  const url = `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/endpoint/establishment/${propertyTicker}/createOrUpdateConfigurations`;
  console.log(`updating ${propertyTicker} defaultbrand: ${defaultBrand}`);
  await axios.post(url, { defaultBrand });
  return regenPropertyCache(cacheClient, propertyTicker);
}

export async function getPropertyDefaultBrand(propertyTicker: string): Promise<string | undefined> {
  const url = `${MIDDLEWARE_URL}/WitBookerAPI-war/webresources/endpoint/establishment/${propertyTicker}/configurations`;
  const params = new URLSearchParams();
  params.append("prop", "defaultBrand");
  return (await axios.get(url, { params })).data.defaultBrand;
}

export async function getActiveChildren(chainData: IPropertyChainData): Promise<string[]> {
  const childrenInfo = await Promise.all(
    chainData.children.map(async it => {
      const propertyDefaultBrand = await getPropertyDefaultBrand(it);
      return propertyDefaultBrand ? it : undefined;
    })
  );
  return childrenInfo.filter((item): item is string => Boolean(item));
}
